<main tabindex="0" aria-label="Main content">
    <router-outlet></router-outlet>
</main>
